import { LogIn, Plus, RefreshCw, Trash2, Eye } from 'lucide-react';

export const STATUS_COLORS = {
  trial: 'bg-info/20 text-info',
  active: 'bg-success/20 text-success',
  suspended: 'bg-error/20 text-error',
  cancelled: 'bg-muted text-muted-foreground',
};

export const PLAN_COLORS = {
  starter: 'bg-muted text-muted-foreground',
  business: 'bg-orange-100 text-orange-700',
  enterprise: 'bg-warning/20 text-warning',
  internal: 'bg-warning/10 text-warning',
};

export const NOTE_CATEGORIES = ['general', 'support', 'billing', 'bug', 'request'];

export const ACTION_ICONS = {
  login: LogIn,
  create: Plus,
  update: RefreshCw,
  delete: Trash2,
  view: Eye,
};

export const ACTION_COLORS = {
  login: 'bg-info/20 text-info',
  create: 'bg-success/20 text-success',
  update: 'bg-warning/20 text-warning',
  delete: 'bg-error/20 text-error',
  view: 'bg-muted text-muted-foreground',
};
